<!-- 公示投票 -->
<template>
  <div class="allcontent">
    <div class="page-index main-content">
      <Psdetail />
    </div>
  </div>
</template>

<script>
import Tab from "../components/tab.vue"; // 导航
import Votingrules from "../components/votingrules.vue"; // 投票规则
import Tabsearch from "../components/tabsearch.vue"; // tab搜索
import Psdetail from "../components/psdetail.vue"; // 绘画列表页
export default {
  name: "PageIndex",
  components: {
    Tab,
    Votingrules,
    Tabsearch,
    Psdetail
  },
  data() {
    return {
      isphone: false
    };
  },
  computed: {},
  mounted() {
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    /**
     * ##########################################################################################
     * @description 切换烈士列表页码
     * @param {Number} currentPage : 切换后的页码
     * ##########################################################################################
     */

    changeCurrentPage(currentPage) {
      this.currentPage = currentPage;
      this.getList();
      console.log("最新页码：" + currentPage);
    },
    /**
     * ##########################################################################################
     * @description 调用著名烈士列表接口
     * ##########################################################################################
     */

    getList() {
      // TODO: request login api
      var types = "207d0d1da40742fa851616985efd3f0e";
      var data = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        type: types
      };
      this.loading = true;
      martyrList(data, types).then(res => {
        console.log("res：", res);
        // if (res.code) {
        //   if (res.code == 200) {
        //     this.martyrsTotal = res.total;
        //     this.martyrsList = res.rows;
        //     this.loading = false;
        //   } else {
        //     this.$message.error(res.msg);
        //     this.loading = false;
        //   }
        // } else {
        this.martyrsTotal = res.length;
        this.martyrsList = res.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
        this.loading = false;
        // }
      });
    }
  }
};
</script>

<!-- 覆盖ElementUI样式 -->
<style type="text/css" scoped>
.allcontent {
  background: url(../assets/images/toupiao/bottombg.png) bottom center no-repeat,
    linear-gradient(#f7e3db, #fdf6f2, #fff6f1);
  background-size: 100%;
}
.parentitem {
  padding-bottom: 150px;
}

.content-center {
  width: 1200px;
  margin: 0 auto;
}
.content-indent {
  /* 缩进两个字 */
  text-indent: 2em;
  /* 左右对齐 */
  text-align: justify;
  /* 内容显示几行 限制的行数在指定的css中写 -webkit-line-clamp: 6; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 1.7em;
  font-family: "Courier New", Courier, monospace;
}
/* 不让选中文字 */
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  -khtml-user-select: none;
  /* Konqueror */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currentlynot supported by any browser */
}
/* 文字抖动 */
@keyframes animate {
  0%,
  100% {
    text-shadow: -1.5px -1.5px 0 #0ff, 1.5px 1.5px 0 #f00;
  }
  25% {
    text-shadow: 1.5px 1.5px 0 #0ff, -1.5px -1.5px 0 #f00;
  }
  50% {
    text-shadow: 1.5px -1.5px 0 #0ff, 1.5px -1.5px 0 #f00;
  }
  75% {
    text-shadow: -1.5px 1.5px 0 #0ff, -1.5px 1.5px 0 #f00;
  }
}
/* 图片抖动 */
@-moz-keyframes tada {
  0% {
    -moz-transform: scale(1);
  }
  10%,
  20% {
    -moz-transform: scale(0.9) rotate(-3deg);
  }
  30%,
  50%,
  70%,
  90% {
    -moz-transform: scale(1.2) rotate(3deg);
  }
  40%,
  60%,
  80% {
    -moz-transform: scale(1.2) rotate(-3deg);
  }
  100% {
    -moz-transform: scale(1) rotate(0);
  }
}
@-webkit-keyframes tada {
  0% {
    -webkit-transform: scale(1);
  }
  10%,
  20% {
    -webkit-transform: scale(1) rotate(-2deg);
  }
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: scale(1.05) rotate(2deg);
  }
  40%,
  60%,
  80% {
    -webkit-transform: scale(1.05) rotate(-2deg);
  }
  100% {
    -webkit-transform: scale(1) rotate(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pingshen.vue